<!-- Taken from https://vuejsdevelopers.com/2017/10/23/vue-js-tree-menu-recursive-components/ -->
<template>
  <span :class="['evaluation-badge', 'badge', 'badge-value-' + value, outline ? 'badge-parent' : null]">
    {{ choices[value] }}
  </span>
</template>

<style>
.badge {
  margin-right: 5px;
  position: relative;
  top: -1px;
}
</style>

<script>
export default {
  name: 'EvaluationBadge',

  props: {
    outline: {
      default: false,
      required: false,
      type: Boolean
    },
    value: {
      default: 0,
      required: true,
      type: [Number, String]
    }
  },

  data: () => ({
    choices: ['0', '1', '2', '3', '4', 'X'],
  }),
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/EvaluationBadge.vue